<div id="detalle-movimientos">
    <h3>Detalle de movimientos <i>(últimos 24 meses)</i></h3>
    <div class="results" *ngIf="detalle.length > 0">
      <p-table [value]="detalle" [rows]="5" [paginator]="true" styleClass="tabla-restitucion">
        <ng-template pTemplate="header">
          <tr>
              <th>Movimiento</th>
              <th>Folio</th>
              <th>Tipo de movimiento</th>
              <th>Estado</th>
              <th>Cargo / abono</th>
              <th>Monto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-detalle>
          <tr>
            <td>{{detalle.fechaMovimiento | date:'dd/MM/yyyy'}}</td>
            <td>{{detalle.codigoMovimiento}}</td>
            <td>{{detalle.glosaTipoMovimiento }}</td>
            <td>{{detalle.glosaEstadoMovimiento }}</td>
            <td>
              <ng-container *ngIf="detalle.tipoMovimiento === 'C' ">
                Cargo
              </ng-container>
              <ng-container *ngIf="detalle.tipoMovimiento === 'A' ">
                Abono
              </ng-container>
              
            </td>
            <td>${{detalle.montoMovimiento | number:'1.0-0' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="6">No se han encontrado movimientos</td>
                </tr>
              </ng-template>
      </p-table>
    </div>
    <!-- <a (click)="backClicked()"class="backTitle"> < Volver</a> -->
  
  </div>
  